import type { ServiceProvider, ServiceContainer } from "../service-container";
import { BaseDistortionProcessorFactory } from "./BaseDistortionProcessorFactory";
import { DistortionController } from "./DistortionController";
import { DistortionService } from "./DistortionService";

/**
 * Distortion processing service provider.
 * @internal
 */
export const distortionProcessingProvider: ServiceProvider = {
  /**
   * Registers entities, related to distortion processing, in service container.
   * @param container
   */
  register(container: ServiceContainer) {
    container.register(
      "DistortionProcessorFactory",
      () => new BaseDistortionProcessorFactory()
    );

    container.register("DistortionController", (c) => {
      return new DistortionController(
        c.resolve("OutputViewportResolver"),
        c.resolve("DistortionProcessorFactory")
      );
    });

    container.register("DistortionService", (c) => {
      return new DistortionService(
        c.resolve("ReversePixelMapperResolver"),
        c.resolve("ColorResamplerResolver"),
        c.resolve("DistortionController"),
        c.resolve("ImageAdapterResolver"),
        c.resolve("ColorStringParser"),
        c.resolve("VirtualPixelDecoratorApplicator")
      );
    });
  },
};
